import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const useFetchClientsResults = (promoId, accessToken) => {
    const [hasPendingPrize, setHasPendingPrize] = useState(false);
    const [results, setResults] = useState([]);

    const fetch = useCallback(() => {
        if (!promoId) {
            return
        }

        if (!accessToken) {
            return;
        }

        axios.get(`${process.env.REACT_APP_API_URL}/client/me/results?promo_id=${promoId}`, {
                headers: {
                'Authorization': `Bearer ${accessToken}`
                },
            })
            .then((response) => {
                const res = response.data.data;
                setResults(res);
                setHasPendingPrize(res.some((result) => result.status === 'aguardando'));
            })
            .catch((err) => {
                setResults([]);
                console.error(err);
            })
    }, [promoId, setResults, accessToken])

    useEffect(() => fetch(), [fetch, promoId]);

    return { results, hasPendingPrize, fetch };
}

export default useFetchClientsResults;